// extracted by mini-css-extract-plugin
module.exports = {"debug":"Debug_debug__2XR1y","title":"Debug_title__3tabT","content":"Debug_content__1ZSw0"};